import { Typography } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import { WHITE } from '~/Constants/Colors.constants';
import { SliderArrow } from '.';
import { onboardingPage } from '../IOnboardingData.model';

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: 250,
    right: 'calc(30% - 64px)',
    maxWidth: 190,
    '& .slick-slider': {
      '& .slick-track': {
        display: 'flex',
        '& > div': {
          alignSelf: 'center',
        },
      },

      '& svg': {
        color: 'WHITE',
        opacity: 0.25,
        transition: 'opacity .3s ease-in-out',
        '&:hover': {
          opacity: 1,
        },
      },

      '& .slick-dots button:before': {
        color: WHITE,
      },
    },

    [theme.breakpoints.down('md')]: {
      display: 'block',
      margin: 'auto',
      marginTop: 30,
      position: 'unset',
    },
  },

  container: {
    textAlign: 'center',
    wordBreak: 'break-word',
    overflow: 'hidden',
  },

  text: {
    color: WHITE,
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '16px',
  },

  user: {
    color: WHITE,
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '16px',
    textAlign: 'center',
    wordBreak: 'break-word',
  },
  dash: {
    borderTop: `2px solid ${WHITE}`,
    width: 14,
    margin: '12px auto',
  },
}));

export interface IOnboardingSliderProps {
  pageName: string;
}

export const OnboardingSlider = ({ pageName }: IOnboardingSliderProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <Slider
        dots
        speed={500}
        slidesToShow={1}
        slidesToScroll={1}
        nextArrow={<SliderArrow direction="right" />}
        prevArrow={<SliderArrow direction="left" />}
      >
        <div className={classes.container}>
          <Typography
            className={classes.text}
            dangerouslySetInnerHTML={{
              __html: t(`onboarding.testimonial${pageName === onboardingPage.STUDIO ? 1 : 3}`),
            }}
          />
          <div className={classes.dash} />
          <Typography className={classes.user}>
            {t(`onboarding.testimonial${pageName === onboardingPage.STUDIO ? 1 : 3}.info`)}
          </Typography>
        </div>

        <div className={classes.container}>
          <Typography
            className={classes.text}
            dangerouslySetInnerHTML={{
              __html: t(`onboarding.testimonial${pageName === onboardingPage.STUDIO ? 2 : 4}`),
            }}
          />
          <div className={classes.dash} />
          <div className={classes.user}>
            {t(`onboarding.testimonial${pageName === onboardingPage.STUDIO ? 2 : 4}.info`)}
          </div>
        </div>
      </Slider>
    </div>
  );
};
